import React, { Component } from "react";
import {
  Button,
  Container,
  Form,
  Card,
  Row,
  Col,
  Modal,
  Image,
  Table
} from "react-bootstrap";
import "../Common/Common.css";
import ReactPaginate from "react-paginate";
import ViewInvoice from "./ViewInvoice";
//import Pusher from "pusher-js";
import { DropdownButton, OverlayTrigger, Tooltip } from "react-bootstrap";
var dateFormat = require("dateformat");

class Invoice extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showdetailModal: false,

      searchInvoice: "",
      filterInvoice: "",

      page: 0,
      perPage: 10
    };
  }

  componentDidMount() {
    /* let user = JSON.parse(localStorage.getItem("userDetails"));

    const this2 = this;
    const pusher = new Pusher("1fed1b5bb402ad82467e", {
      cluster: "ap2"
    });

    var paidInvoice;
    paidInvoice = pusher.subscribe(user.id);

    paidInvoice.bind("paid", function(data) {
      console.log("pusher working");
      this2.props.getInvoices({
        page: undefined,
        search: this2.state.searchInvoice,
        filter: this2.state.filterInvoice
      });
    }); */

    this.props.getInvoices({
      page: undefined,
      search: this.state.searchInvoice,
      filter: this.state.filterInvoice
    });
  }

  showInvoiceModal = item => {
    this.setState({
      ...this.state,
      showdetailModal: true,
      invoiceDetail: item
    });
  };

  closeInvoiceModal = () => {
    this.setState({
      ...this.state,
      showdetailModal: false
    });
  };

  //For pagination
  handleinvoicePageClick = e => {
    const selectedinvoicePage = e.selected;
    this.props.invoicepageSelected({
      page: selectedinvoicePage + 1,
      search: this.state.searchInvoice,
      filter: this.state.filterInvoice
    });
    this.setState({ page: selectedinvoicePage });
  };

  resetPage = () => {
    this.setState({ page: 0 });
  };

  //For Filter
  invoiceFilterChange = ev => {
    this.setState(
      {
        ...this.state,
        page: 0,
        searchInvoice: "",
        filterInvoice: ev.target.value
      },
      () => {
        this.props.getInvoices({
          page: undefined,
          search: "",
          filter: this.state.filterInvoice
        });
      }
    ); //synchronous call
  };

  //For search
  invoiceSearch = ev => {
    this.setState(
      {
        ...this.state,
        searchInvoice: ev.target.value,
        filterInvoice: "",
        page: 0
      },
      () => {
        this.props.getInvoices({
          page: undefined,
          search: this.state.searchInvoice,
          filter: ""
        });
      }
    ); //synchronous call
  };

  renderTooltip = props => (
    <Tooltip id="button-tooltip" {...props}>
      View
    </Tooltip>
  );

  render() {
    //Destructuring
    const { invoiceList, invoiceListCount } = this.props;
    const {
      page,
      perPage,
      filterInvoice,
      searchInvoice,
      showdetailModal,
      invoiceDetail
    } = this.state;
    const {
      invoiceFilterChange,
      invoiceSearch,
      resetPage,
      handleinvoicePageClick,
      closeInvoiceModal,
      showInvoiceModal
    } = this;

    //For Pagination
    const count = invoiceListCount;
    let p = page + 1;
    let invoicePageCount = Math.ceil(count / perPage);

    return (
      <div className="salesreturndiv">
        <Card>
          {/* <Card.Header className="commontableheader"> */}
          <div className="salesheader">
            <Row>
              <Col xs={12} sm={12} md={3} lg={3}>
                <div>
                  <h5 className="tablecardtitle">Invoices</h5>
                </div>
                {/* <h5 className="commontableheadername">Invoices</h5> */}
              </Col>
              <Col xs={12} sm={12} md={3} lg={3}>
                <div className="commonInputdiv">
                  <div className="commonInput">
                    <i className="fa fa-search fa-lg cmnSearchIcon"></i>
                    <input
                      type="text"
                      placeholder="Reference Number"
                      value={searchInvoice}
                      onChange={invoiceSearch}
                    />
                  </div>
                </div>
              </Col>
              <Col xs={12} sm={12} md={3} lg={3}>
                <div className="commonFilterDiv">
                  <select
                    value={filterInvoice}
                    onChange={invoiceFilterChange}
                    className="commonFilterSelect"
                  >
                    <option value="">All</option>
                    <option value="open">Open</option>
                    {/* <option value="partial">Partial</option> */}
                    <option value="paid">Paid</option>
                    <option value="cancelled">Cancelled</option>
                  </select>
                </div>
              </Col>
              <Col xs={12} sm={12} md={3} lg={3}>
                <div className="salescommonRecrd">
                  <i className="cui-note icons cmnRecordIcon"></i>
                  <span className="cmnPageCount">
                    {invoiceListCount === undefined ? (
                      0
                    ) : (
                      <span>{invoiceListCount}</span>
                    )}
                  </span>
                  <span className="cmnResutText">Results</span>
                </div>
              </Col>
            </Row>
          </div>
          {/* </Card.Header> */}
          <Card.Body className="tableCardBody">
            <div className="tablecommonCardBody">
              <Table hover responsive className="">
                <thead className="tablecommonCard">
                  <tr>
                    <th>#</th>
                    <th>Reference No</th>
                    <th>Order No</th>

                    <th>Organization Name</th>
                    {/* <th>Payment Type</th> */}
                    <th>Payment Mode</th>
                    <th>Amount </th>
                    <th>Created Date</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                {invoiceList !== undefined &&
                  invoiceListCount !== 0 &&
                  invoiceList.map((item, i) => (
                    <tbody key={i} className="">
                      <tr>
                        <th scope="row">{10 * (p - 1) + i + 1}</th>
                        <td className="cmn_Cap">{item && item.invNo}</td>
                        <td className="cmn_Cap">
                          {item && item.orderId && item.orderId.orderNo}
                        </td>

                        <td className="cmn_Cap">
                          {" "}
                          {item && item.chmstDtls && item.chmstDtls.name}
                        </td>
                        {/* <td className="cmn_Cap">
                          {" "}
                          {item && item.orderId && item.orderId.payType&&(item.orderId.payType==="payNow"?"Prepaid":"Postpaid")}
                        </td> */}
                        <td className="cmn_Cap">
                          {item !== null && item.orderId && item.orderId.payMode}
                        </td>
                        <td className="cmn_Cap">
                          {item !== null && item.amount?"INR "+item.amount:null}
                        </td>
                        <td>
                          {item && dateFormat(item.createdAt, "dd-mmm-yyyy")}
                        </td>
                        <td className="cmn_Cap">
                          {/* {item && item.status} */}
                          {item !== null && item.status === "open" ? (
                            <span className="badge badge-primary">
                              {" "}
                              {item !== null && item.status
                                ? item.status
                                : null}
                            </span>
                          ) : item !== null && item.status === "paid" ? (
                            <span
                              className="badge badge-success "
                              style={{
                                paddingLeft: "10px",
                                paddingRight: "10px"
                              }}
                            >
                              {" "}
                              {item !== null && item.status
                                ? item.status
                                : null}
                            </span>
                          ) : (
                            <span className="badge badge-danger">
                              {" "}
                              {item !== null && item.status
                                ? item.status
                                : null}
                            </span>
                          )}
                        </td>
                        <td className="cmnViewIcon">
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center"
                            }}
                          >
                            <OverlayTrigger
                              placement="bottom"
                              delay={{ show: 250, hide: 400 }}
                              overlay={this.renderTooltip}
                            >
                              <i
                                className="fa fa-eye fa-lg "
                                onClick={() => showInvoiceModal({ item: item })}
                              ></i>
                            </OverlayTrigger>

                            {/* <i
                              className="fa fa-eye fa-lg "
                              onClick={() => showInvoiceModal({ item: item })}
                            ></i> */}
                            
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  ))}
                  <ViewInvoice
                    show={showdetailModal}
                    close={closeInvoiceModal}
                    invoiceDetail={invoiceDetail}
                  />
              </Table>
              {invoicePageCount > 1 ? (
                <div className="paginationDiv">
                  <ReactPaginate
                    forcePage={page}
                    previousLabel={"Prev"}
                    nextLabel={"Next"}
                    breakLabel={"..."}
                    breakClassName={"break-me"}
                    pageCount={invoicePageCount}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={5}
                    onPageChange={handleinvoicePageClick}
                    containerClassName={"pagination flex-wrap"}
                    subContainerClassName={"pages pagination"}
                    activeClassName={"active"}
                  />
                </div>
              ) : null}
              {(invoiceList === undefined ||
                (invoiceList && invoiceListCount === 0)) && (
                <div>
                  <div className="noDataImgDiv">
                    <Image
                      className="noDataImg"
                      src={require("../../assets/img/nodata4.png")}
                    />
                  </div>
                  <div className="noDataTextDiv">No invoices found</div>
                </div>
              )}
            </div>
          </Card.Body>
        </Card>
      </div>
    );
  }
}

export default Invoice;
